<template>
  <div class="help-section help-faq">
    <div class="section-header">
      <div @click="back" class="icon icon--s icon-back mr-3"></div>
      FAQ
    </div>
    <div class="section-intro"></div>
    <div class="section-content">
      <iframe src="https://tfull.bancaprofilo.it/conf/help/faq/" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpFAQ",
  components: {},

  data() {
    return {};
  },
  mounted() {},
  methods: {
    getWhatsappLink() {
      const whatsappMessage = "Buongiorno, ho bisogno di assistenza!";

      /**
       * Use https://wa.me/<number> where the <number> is a full phone number in international format.
       * Omit any zeroes, brackets, or dashes when adding the phone number in international format.
       * Source: https://faq.whatsapp.com/general/chats/how-to-use-click-to-chat
       */
      
      const whatsappPhoneNumber = "393371425932"; //

      return `https://wa.me/${whatsappPhoneNumber}?text=${encodeURI(
        whatsappMessage
      )}`;
    },
    back() {
      console.log("back");
      this.$root.$emit("helpBack");
    }
  }
};
</script>
<style lang="less" scoped>
.section-content,
iframe {
  height: 100%;
  width: 100%;
}
</style>
